var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDott(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-circle-down"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-circle-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.00033 13.2703C10.222 13.2703 12.8337 10.6586 12.8337 7.43697C12.8337 4.21531 10.222 1.60364 7.00033 1.60364C3.77866 1.60364 1.16699 4.21531 1.16699 7.43697C1.16699 10.6586 3.77866 13.2703 7.00033 13.2703Z",
    fill: "#27C6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDott);
export default __webpack_public_path__ + "static/media/dott.121735886acdf59cc75db4bdb4a3087b.svg";
export { ForwardRef as ReactComponent };